import { Dialog, Modal } from '@mui/material';
import Api from 'app/services/api';
import React, { useEffect, useRef, useState } from 'react';

const ConfirmationModal = ({
  warrantyData,
  onSubmit,
  onClose,
  isOpen = false,
  loading = false,
}) => {
  const [isChecked, setIsChecked] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    setTimeout(() => {
      ref.current?.scrollIntoView({
        behavior: 'smooth',
      });
      // const el = document.getElementById('content')
      // el?.scrollIntoView({behavior: 'smooth'})
    }, 150);
  }, [ref]);

  if (!warrantyData) return;
  const {
    factor_picture,
    box_picture,
    warranty_number,
    brand,
    model,
    imei,
    price,
    vat_price,
    warranty_price,
    first_name,
    last_name,
    customer_mobile,
    customer_national_id,
  } = warrantyData;

  const handleCheckboxChange = () => {
    setIsChecked(!isChecked);
  };

  return (
    <Dialog onClose={onClose} open={isOpen}>
      <div className="p-4 border border-gray-200 rounded-lg rtl shadow">
        <p className="mb-8 border rounded p-4 bg-gray-100" ref={ref}>
          لطفاً اطلاعات خریدار و گوشی را به دقت بررسی کنید و در صورت صحت، تایید را انجام دهید{' '}
        </p>
        <div className="mb-4 flex justify-between">
          <span className="text-lg font-bold">شماره سریال گارانتی:</span>
          <span>{warranty_number}</span>
        </div>
        <div className="mb-4 flex justify-between">
          <span className="text-lg font-bold">برند:</span>
          <span>{brand?.label}</span>
        </div>
        <div className="mb-4 flex justify-between">
          <span className="text-lg font-bold">مدل:</span>
          <span>{model?.label}</span>
        </div>
        <div className="mb-4 flex justify-between">
          <span className="text-lg font-bold">IMEI:</span>
          <span>{imei}</span>
        </div>
        <div className="mb-4 flex justify-between">
          <span className="text-lg font-bold">مشخصات خریدار:</span>
          <span>{first_name + ' ' + last_name}</span>
        </div>
        {customer_national_id && (
          <div className="mb-4 flex justify-between">
            <span className="text-lg font-bold">کد ملی:</span>
            <span>{customer_national_id}</span>
          </div>
        )}
        <div className="mb-4 flex justify-between">
          <span className="text-lg font-bold">قیمت دستگاه:</span>
          <span>{price?.toLocaleString('fa-IR')} تومان</span>
        </div>
        {/* <div className="mb-4">
          <p className="text-lg font-bold">
            مالیات: {vat_price?.toLocaleString("fa-IR")} تومان
          </p>
        </div>
        <div className="mb-4">
          <p className="text-lg font-bold">
            قیمت گارانتی:{" "}
            {(warranty_price + vat_price)?.toLocaleString("fa-IR")} تومان
          </p>
        </div> */}
        <div className="mb-4">
          {factor_picture && (
            <img
              src={Api.getPhotoUrl(factor_picture)}
              alt="Factor Picture"
              className="mb-2 w-full"
            />
          )}
          {box_picture && (
            <img src={Api.getPhotoUrl(box_picture)} alt="Box Picture" className="w-full" />
          )}
        </div>
        {onSubmit && (
          <div className="flex justify-between">
            <div>
              <button
                type="submit"
                disabled={loading}
                className="bg-primary text-white p-2 rounded"
                onClick={onSubmit}
              >
                تایید
              </button>
            </div>
            <div>
              <button
                type="submit"
                // disabled={loading}
                className="bg-gray-500 text-white p-2 rounded"
                onClick={onClose}
              >
                اصلاح
              </button>
            </div>
          </div>
        )}
      </div>
    </Dialog>
  );
};

export default ConfirmationModal;
